import Base from '../base'

export default {
  addItem: (cartId, item) => Base.post(`/cart/${cartId}/add`, item),
  changeQuantity: (cartId, data) => Base.post(`/cart/${cartId}/change-quantity`, data),
  getCart: (cartId) => Base.get(`/cart/${cartId}`),
  clearCart: cartId => Base.post(`/cart/${cartId}/clear`)
}
